export const organizationData = [
  {
    id: 1,
    code: "#VLZ10",
    name: "Accounts",
    contactName: "Aatish",
    email: "abc@gamil.com",
    status: "ACTIVE",
  },
];

export const orgMappingData = [
  {
    id: 1,
    code: "#VLZ10",
    org_relationship: "Department",
    node: "",
    action: "LINKED",
  },
];

export const organizationTabs = [
  { label: "Details", value: "details" },
  // { label: "Org Mapping", value: "org_mapping" },
];
